import React, { useEffect } from 'react';

const ClientSideRedirect = ({ pageContext, location }) => {

    useEffect(() => {
    	if (location.href.includes("?")){
			window.location.replace(`${pageContext.toPath}?${location.href.split(/\?(.+)/)[1]}`)
    	} else {
    		window.location.replace(`${pageContext.toPath}`)
    	}
	}, [])

  return (
    <div>

    </div>
   );

};

export default ClientSideRedirect;